<template>
    <colored-letter-square
            :name="firstRole"
            :length="1"
            :color="color"
    ></colored-letter-square>
</template>

<script>
    export default {
        props: ['data'],

        computed: {
            firstRole() {
               return this.data.role_trans.split(',')[0];
            },
            color() {
                // spilt for multiple roles, select the first role as main color.
                switch (this.firstRole) {
                    case this.trans('users.role.admin'):
                        return '#9acd7d';
                    case this.trans('users.role.editor'):
                        return '#9ddbd7';
                    case this.trans('users.role.accounting'):
                        return '#f48fb1';
                    case this.trans('users.role.client_admin'):
                        return '#b39ddb';
                    case this.trans('users.role.supervisor'):
                        return '#db9dd9';
                    case this.trans('users.role.controller'):
                        return '#f5b266';
                    case this.trans('users.role.end_user'):
                        return '#64b5f6';
                    case this.trans('users.role.support'):
                        return '#9ddbd7';
                    default:
                        return '#007d40';
                }
            },
        },
    }
</script>
